import {CardMedia} from "@mui/material";

export default function EnhancedCardImage({ image, height }) {
    const isTop = image.includes("-top");
    return (
        <CardMedia
            component="img"
            image={image}
            alt=""
            sx={{
                height: height,
                width: "100%",
                objectFit: "cover",
                objectPosition: isTop ? "top" : "center",
                transition: "object-position 0s ease",
            }}
        />
    );
}